import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function bulkStatusReducer(state = initialState.batchFileStatus, action) {
    switch (action.type) {
        case types.LOAD_STATUS_SUCCESS:
            return action.batchFileStatus;
        default:
            return state;
    }
}
